const ActivityOpportunitiesTab = () => {
  return (
    <div
      style={{
        padding: "0px 30px",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        gap: 20,
      }}
    >
      <h1>Activity Opportunities</h1>
    </div>
  );
};

export default ActivityOpportunitiesTab;
